'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
function ItemInfoPanel(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.init();
}

ItemInfoPanel.prototype = $.extend({}, {
    construtor: 'ItemInfoPanel',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        /*
        _this.$container.find('.date').off('click');
        _this.$container.find('.date').on('click', function dateClickClb() {
            _this.setDate($(this).data('date'));

            return false;
        });

        _this.$container.find('.window-date').off('click');
        _this.$container.find('.window-date').on('click', function windowDateClickClb() {
            _this.addItemToBasket(_this.$container.find('table tr th:eq(' + $(this).index() +  ')').data('date'), $(this).closest('tr').data('id'));

            return false;
        });
        */

        return _this;
    },

    /*
    setDate: function setDate(date) {
        var _this = this;

        if (services.has('catalogItemsBasket')) {
            services.get('catalogItemsBasket').setDate(date);
        }

        return _this;
    },

    addItemToBasket: function addItemToBasket(date, windowId) {
        var _this = this;

        if (services.has('catalogItemsBasket')) {
            services.get('catalogItemsBasket').addItemToBasket(_this.$container.data('item_id'), date, windowId, function () {
                _this.setDate(date);
            });
        }

        return _this;
    },
    */

    loadOverview: function loadOverview() {
        var _this = this;

        blockElement(_this.$container);
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=item-detail&method=js_load_item_info_panel&id=' + _this.$container.data('item_id'), function loadOverviewClb(res) {
            unBlockElement(_this.$container);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$container.html(res.data.html);
                    _this.registerCallbacks();
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.loadOverview();

        return _this;
    }
});
